import FunnelHeader from "@components/quiz/FunnelHeader"
import FunnelLayout from "@components/quiz/FunnelLayout"
import { canGoBack } from "@helpers/history"
import { ReactNode } from "react"
import { useNavigate } from "react-router-dom"

/**
 * The help center's page: the funnel's logo header (with a back button when
 * there is a page to go back to).
 */
export default function HelpCenterLayout({
  children,
}: {
  children: ReactNode
}) {
  const navigate = useNavigate()

  return (
    <FunnelLayout
      header={
        <FunnelHeader onBack={canGoBack() ? () => navigate(-1) : undefined} />
      }
    >
      <div className="flex grow flex-col gap-6 pb-10 pt-4">{children}</div>
    </FunnelLayout>
  )
}
